module.exports = __webpack_public_path__ + "img/banner2.cb2483b8.png";